import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  CardText,
} from "reactstrap";
import moment from "moment";

import staffService from "../../services/staffService";
import PrintMeetingDayCards from "./PrintMeetingDayCards";
import { useReactToPrint } from "react-to-print";

const PrintMeetingDay = (props) => {
  const componentRef = React.useRef();
  const handlePrint = useReactToPrint({ content: () => componentRef.current });

  const [modal, setModal] = useState(false);
  const [hideButton, setHideButton] = useState(false);
  const [dateArr, setDateArr] = useState([]);

  const toggle = () => setModal(!modal);
  useEffect(() => {
    if (props.date === "") {
      setHideButton(true);
      setDateArr([]);
    } else {
      setHideButton(false);
      staffService
        .getScheduledAppointmentsByDate(props.date)
        .then((payload) => {
          //console.log(payload);

          setDateArr(payload);
        });
    }
  }, [props.date]);

  // For tomorrow I can send a
  return (
    <div>
      <Button color="danger" onClick={toggle} disabled={hideButton}>
        Print daily calendar
      </Button>
      <Modal isOpen={modal} toggle={toggle} size="xl">
        <ModalHeader toggle={toggle}>Print calendar</ModalHeader>
        <ModalBody>
          <PrintMeetingDayCards dateArr={dateArr} ref={componentRef} />
        </ModalBody>
        <ModalFooter>
          <Button onClick={handlePrint}>Print</Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default PrintMeetingDay;
